export default "__VITE_ASSET__Gmgezws1__"